import {Component, Input, ViewChild} from '@angular/core';
import {ModalCapable} from '../../../../../components/common/modal/modalCapable';
import {ModalOption} from '../../../../../components/common/modal/modalOption';
import {ModalComponent} from '../../../../../components/common/modal/modal.component';
import {ProductModel} from '../../entity/product.model';
import {ProductSaveService} from '../../../impl/service/product-save.service';
import {PartnerModel} from '../../../../partner/common/api/model/partner.model';
import {IDialogComponent} from '../../../../common/dialog/iDialog.component';
import {DialogWithInput} from '../../../../common/dialog/dialogWithInput';

export interface ProductSaveDialogInput {
    typeValue: string;
}
export interface ProductSaveDialogResult {
    entity: ProductModel;
}

@Component({
    selector: 'app-product-save-modal',
    templateUrl: './product-save-modal.component.html',
    viewProviders: [ProductSaveService]
})
export class ProductSaveModalComponent implements
    IDialogComponent<ProductSaveDialogInput, ProductSaveDialogResult> {
    dialog: DialogWithInput<ProductSaveDialogInput, ProductSaveDialogResult>;

    constructor() {
    }

    onEntitySaved(entity: ProductModel) {
        this.dialog.close({
            entity
        });
    }

}
